<template>
    <ShadowBoxContainer>
        <CardShell class="pb3 pb4-ns col-sm-8 col-md-6 col-lg-5 center mt4-ns">
            <div class="ph3 ph4-ns">

                <!-- title -->
                <h4 class="pv3">Edit Photo</h4>

                <div class="w-100 pa2 tc">
                    <ImageEdit class="ba b--mid-gray w-100" :img="listing.files[$route.params.index]" ref="imageEdit"></ImageEdit>
                </div>

                <!-- edit buttons -->
                <div class="mt2 w-80 w-70-ns flex justify-between center">
                    <div class="bg-light-gray pv1 ph2">
                        <img style="width:20px;" class="pointer grow" src='@/assets/img/photo-edit/icon_photoedit_rotate.svg' @click="$refs.imageEdit.rotate()" />
                    </div>
                    <div class="bg-light-gray pv1 ph2">
                        <img class="pr3 w2-ns pointer grow" src='@/assets/img/photo-edit/icon_photoedit_zoomin.svg' @click="$refs.imageEdit.zoom(1)" />
                        <img class="w2-ns pointer grow" src='@/assets/img/photo-edit/icon_photoedit_zoomout.svg' @click="$refs.imageEdit.zoom(-1)"/>
                    </div>
                    <div style="background-color: #FBEDEB" class="pv1 ph2 pointer grow">
                        <img class="w2-ns" src='@/assets/img/photo-edit/icon_photoedit_delete.svg' @click="onDeleteClick()" />
                    </div>
                </div>

            </div>
        </CardShell>

        <!-- buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Cancel" forward="Save" @backClick="$router.push('/add-photos')" @forwardClick="save" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ImageEdit from '@/components/controls/ImageEdit.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        NavigationButtons,
        ShadowBoxContainer,
        ImageEdit,
        CardShell
    },
    computed: {
        ...mapState('newListing', ['listing'])
    },
    methods: {
        ...mapMutations('newListing', ['removeFile']),
        onDeleteClick() {
            this.removeFile(this.$route.params.index);
            this.$router.push({ path: '/add-photos' });
        },
        save() {
            this.listing.files[
                this.$route.params.index
            ] = this.$refs.imageEdit.toDataURL();
            this.$router.push('/add-photos');
        }
    }
};
</script>
